import {
  Component,
  OnInit,
  ViewContainerRef,
  ViewChild,
  ComponentRef,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as type from '../../shared/action.event';
import { SearchService } from '../../services/search.service';
import { SettingComponent } from '../nav-components/setting/setting.component';
import { UserComponent } from '../nav-components/user/user.component';
import { HelpComponent } from '../nav-components/help/help.component';
import { ShoppingCartComponent } from '../nav-components/shopping-cart/shopping-cart.component';
import { CompanyInformationComponent } from '../../my-account/company-information/company-information.component';
import { FeedBackComponent } from '../nav-components/feed-back/feed-back.component';
import { EventListenerService } from '../../services/close-listenenr.service';
import { CurrentUserModel, CompanyInfoViewModel } from '../../models/account-ledger.model';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { CommonService } from '../../services/common.service';
import {
  BrandListReturn,
  MetaModel
} from '../../models/search-brand-result.model';
import { Promotion } from '../../models/marketing.model';
import { MarketingService } from '../../services/marketing.service';
import { DatePipe } from '@angular/common';
import { ShoppingCart, MonitorModel } from '../../models/shopping-cart.model';
import { MessageService } from '../../services/message.service';
// tslint:disable-next-line:import-blacklist
import { Subscription, Subject, Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

// ngrx
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers/index';
import { LoadShoppingCart, CreateShoppingCart, ShoppingCartActionTypes, UpdateShoppingCartSuccess } from '../../actions/shoppingcart.actions';
import { getShoppingCartLoaded, getSelectedShoppingCart, getShoppingCarts, getSelectedShoppingCartTotalPrice } from '../../reducers/shoppingcart.reducer';
import { ApiResponse } from '../../models/api-response.model';
import { map, takeUntil } from 'rxjs/operators';
import { NgProgressService } from '../../services/ngProgress.service';
import { Actions, ofType } from '@ngrx/effects';
import { LocationComponent } from '../nav-components/location/location.component';
import { ChatBotComponent } from '../nav-components/chat-bot/chat-bot.component';
import { DDAIService } from '../../services/dd-ai.service';



declare var $: any;

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit, OnDestroy, AfterViewInit {
  // delete promotion list
  title = 'Promotions';
  narrowMode = false;
  type = 'D';
  promotionDeleteList: Array<Promotion>;
  displayPromotionList: Promotion[] = [];
  isDisplay = false;
  today: number = Date.now();
  time = new DatePipe('en-US');
  show = false;
  aliased = false;

  @ViewChild('entry', { read: ViewContainerRef }) entry: ViewContainerRef;
  @ViewChild('chatbot', { read: ViewContainerRef }) chatbot: ViewContainerRef;

  component: ComponentRef<any>;
  chatbotComponent: ComponentRef<any>;

  public myLocation: string;

  collapseMenu = false;

  breadcumb = false;

  toggleOption = 0;

  isDDAIOpen = false;

  searchField: string;

  isSiteBannerDisplay = false;

  siteBannerColor: string;

  siteBannerText: string;

  showCookiePolicyBanner = true;


  currentUserModel: CurrentUserModel;

  companyInfo: CompanyInfoViewModel;

  currentShoppingCarts: ShoppingCart[] = [];

  // close event
  closesub$;
  createSub$;

  searchedKeyword: string;

  // search brand list
  searchResult: BrandListReturn[];
  // side bar information
  searchBrands: MetaModel;

  blink: boolean = false;
  initialLoaded: boolean = false;
  cartName = '';
  totalPrice = 0;
  tourStep: string;
  feedbackPopupSub$: Subscription;
  ngUnsubscribe: Subject<void> = new Subject<void>();

  // modalDetails = {
  //   title: 'Oops',
  //   content: 'Sorry, our website is not supporing IE anymore, please using Edge instead.'
  // };


  @ViewChild('popover') public popover: NgbPopover;
  @ViewChild('popoverCart') public popoverCart: NgbPopover;

  constructor(
    private closeListener: EventListenerService,
    private _router: Router,
    private searchService: SearchService,
    private shoppingCartService: ShoppingCartService,
    private commonService: CommonService,
    private activeRouter: ActivatedRoute,
    private marketingService: MarketingService,
    private ngProgress: NgProgressService,
    private _messageService: MessageService,
    private authService: AuthService,
    private store: Store<AppState>,
    private _actions$: Actions,
    private ddaiService: DDAIService
  ) {
    this.commonService.set(NgbPopover.prototype, ['_unregisterListenersFn'], function () { });
  }

  ngOnInit() {

    this.ddaiService.toggleDDAI$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => this.toggleDDAI());

    this.tourStep = '';

    let url: string = window.location.toString();
    if (url.includes('dev.dickerdata')) {
      this.isSiteBannerDisplay = true;
      this.siteBannerColor = 'green';
      this.siteBannerText = 'Development';
    } else if (url.includes('staging.dickerdata')) {
      this.isSiteBannerDisplay = true;
      this.siteBannerColor = 'blue';
      this.siteBannerText = 'Staging';
    }


    //cookie policy
    const acceptCookie = this.commonService.readCookie("acceptCookiePolicy");
    if (acceptCookie === 'accepted') {
      this.showCookiePolicyBanner = false;
    }
    
    const myLocation = JSON.parse(this.commonService.readCookie('myWarehouseLocation'));
    if (myLocation) {
      this.myLocation = `${myLocation.out_whse_description}\n\n${myLocation.out_whse_address01} ${myLocation.out_whse_address02} ${myLocation.out_whse_address03} ${myLocation.out_whse_address04}, ${myLocation.out_whse_state}, ${myLocation.out_whse_postcode}`;
    }

    this.commonService.updateLocation.pipe(takeUntil(this.ngUnsubscribe)).subscribe((location: any) => {
      this.myLocation = `${location.out_whse_description}\n\n${location.out_whse_address01} ${location.out_whse_address02} ${location.out_whse_address03} ${location.out_whse_address04}, ${location.out_whse_state}, ${location.out_whse_postcode}`;
    })

    this.commonService.currentStep.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: string) => {
      this.tourStep = res;
      if (res && res === 'step1') {
        this.popover.open();
      } else if (res && res === 'step2') {
        this.popover.close();
        this.popoverCart.open();
      } else if (res && res !== 'step2' && res !== 'step1') {
        if (this.popover.isOpen()) {
          this.popover.close();
        }
        if (this.popoverCart.isOpen()) {
          this.popoverCart.close();
        }
      }
    },
      (error: any) => {
        // tslint:disable-next-line:no-console
        console.info(error);
        this.ngProgress.done();
      });
    // get type function
    // get current date and time
    const tDate = this.time.transform(this.today, 'yyyy-MM-dd' + 'T' + 'HH:mm:ss');
    this.narrowMode = false;
    this.aliased = false;
    this.ngProgress.start();
    this.activeRouter.url.subscribe(value => {
      if (value.length === 0) {
        $('.page-contents').animate({ scrollLeft: 0 }, 400);
      }
      // get tpye D, and expiryDate > present date display
      this.marketingService.getPromotionList(this.type).subscribe((pro: Array<Promotion>) => {
        if (pro == null) {
          this.isDisplay = false;
          this.ngProgress.done();
        } else {
          this.promotionDeleteList = pro;
          this.promotionDeleteList.forEach(promotion => {
            if (tDate >= promotion.startDate && tDate <= promotion.expiryDate) {
              this.displayPromotionList.push(promotion);
            }
          });
          this.displayPromotionList = this.displayPromotionList.reverse();
          if (this.displayPromotionList.length !== 0) {
            this.isDisplay = true;
          } else {
            this.isDisplay = false;
          }

          this.ngProgress.done();
        }

        // if (this.displayPromotionList.length )
        // if (pro != null) {
        //   this.promotionDeleteList = pro;
        //   for (let i = 0; i < value.length; i++) {
        //     if (pro[i].expiryDate.toString() > tDate) {
        //       this.promotionDeleteList[i] = pro[i];
        //     }
        //   }
        // } else {
        //   this.isDisplay = true;
        // }

      },
        (error: any) => {
          // tslint:disable-next-line:no-console
          console.info(error);
          this.ngProgress.done();
        });

      // if (this.commonService.readCookie('CartId')) {
      //   this.shoppingCartService.getShoppingCart().subscribe(sc => {
      //     if (sc) {
      //       if (sc.filter(cart => cart.cartId.toString() == this.commonService.readCookie('CartId')).length) {
      //         this.cartName = sc.filter(cart => cart.cartId.toString() == this.commonService.readCookie('CartId'))[0].cartName;
      //         this.totalPrice = sc.filter(cart => cart.cartId.toString() == this.commonService.readCookie('CartId'))[0].totalPrice;
      //       } else {
      //         this.cartName = sc[0].cartName;
      //         this.totalPrice = sc[0].totalPrice;
      //         this.shoppingCartService.monitorCartId(sc[0].cartId);
      //         this.shoppingCartService.monitorCartIdChange(sc[0].cartId);
      //         this.commonService.savecookies("CartId", sc[0].cartId.toString(), 7);
      //         this.shoppingCartService.setSelected(sc, this.commonService.readCookie('CartId'));
      //       }
      //     }
      //   },
      //     (error: any) => {
      //       console.error(error);
      //       this.ngProgress.done();
      //     });
      // }
    });


    // ngrx
    this.store.dispatch(new LoadShoppingCart());

    const getShoppingCarts$ = this.store.pipe(select(getShoppingCarts));

    const selectedShoppingCart$ = this.store.pipe(select(getSelectedShoppingCart));

    this.store.select(getShoppingCartLoaded).subscribe((isLoaded) => {
      if (isLoaded) {

        getShoppingCarts$.subscribe((shoppingCarts) => {
          if (shoppingCarts.length) {
            let tmpCurrentShoppingCarts = this.currentShoppingCarts;
            this.currentShoppingCarts = shoppingCarts;
            this.shoppingCartService.setCacheShoppingCart(shoppingCarts);
            let isRemove = false;
            if(this.initialLoaded) {
              if(!shoppingCarts.every((e, index) => {
                let tmp = tmpCurrentShoppingCarts[index];
                if(tmp) {
                  if (tmp.totalQuantity > e.totalQuantity) {
                    isRemove = true;
                  }
                  return tmp.accountId == e.accountId && tmp.cartId == e.cartId && tmp.totalPrice == e.totalPrice && tmp.totalQuantity == e.totalQuantity
                } else {
                  return false;
                }
              })) {
                // default msg to prevent wrong msg being displayed for different action
                let displayMsg = 'ok';
                // check if number of carts is changed
                if (shoppingCarts.length != tmpCurrentShoppingCarts.length) {
                  displayMsg = shoppingCarts.length < tmpCurrentShoppingCarts.length ? 'Cart removed' : 'New cart created';
                } else {
                  // if carts number not changes, we then check the result of total quantity
                  displayMsg = isRemove ? 'Item(s) removed from cart' : 'Item(s) added to cart';
                }
                this.runBlink(displayMsg);
              }
            } else {
              this.initialLoaded = true;
            }
          } else {
            this.store.dispatch(new LoadShoppingCart()); // refresh store if no carts exist
          }

        });

        selectedShoppingCart$.subscribe(cart => {
          if (cart) {
            this.cartName = cart.cartName;
          }
        });

        this.store.select(getSelectedShoppingCartTotalPrice).subscribe(price => {
          this.totalPrice = price;
        });

      }
    });

    this.shoppingCartService.aliasChanged.subscribe(hasAliased => {
      // let url = this._router.url;
      // if (url === '/') {
      //   url = window.location.pathname;
      // }

      if (url.indexOf('cart/') > 0) {
        if (!url.includes('order-confirmation') && !url.includes('payment-method')) { // allow payment method page & confirmation page showing
          url = '/myCarts';
        }
      }

      // this.shoppingCartService.currentChange
      //   .subscribe((changeArray: MonitorModel) => {

      //     this.shoppingCartService
      //       .getShoppingCart()
      //       .subscribe(sc => {
      //         if (sc) {
      //           this.currentShoppingCarts = sc;
      //           this.shoppingCartService.setCacheShoppingCart(sc);
      //           if (sc.filter(cart => cart.cartId.toString() === this.commonService.readCookie('CartId')).length) {
      //             this.cartName = sc.filter(cart => cart.cartId.toString() === this.commonService.readCookie('CartId'))[0].cartName;
      //             this.totalPrice = sc.filter(cart => cart.cartId.toString() === this.commonService.readCookie('CartId'))[0].totalPrice;
      //           } else {
      //             this.cartName = sc[0].cartName;
      //             this.totalPrice = sc[0].totalPrice;
      //             this.shoppingCartService.monitorCartId(sc[0].cartId);
      //             this.shoppingCartService.monitorCartIdChange(sc[0].cartId);
      //             this.commonService.savecookies('CartId', sc[0].cartId.toString(), 7);
      //             this.shoppingCartService.setSelected(sc, this.commonService.readCookie('CartId'));
      //           }
      //         }
      //       },
      //         (error: any) => {
      //           console.error(error);
      //           this.ngProgress.done();
      //         });
      //   },
      //     (error: any) => {
      //       console.error(error);
      //     });

      this.update_TopNavUser();
      this.setCurrentToggle(0);
      // this._router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      //   this._router.navigate([url]));
    });

    this._actions$.pipe(ofType(ShoppingCartActionTypes.UpdateShoppingCartSuccess)).subscribe((val: UpdateShoppingCartSuccess)=> {
      this.cartName = val.payload.cartName;
    })
    // this.shoppingCartService.currentCartId.subscribe((cartId: number) => {

    //   if (cartId && cartId > 0 && this.currentShoppingCarts.length > 0) {
    //     if (this.currentShoppingCarts.filter(i => i.cartId === cartId).length > 0) {
    //       this.cartName = this.currentShoppingCarts.filter(i => i.cartId === cartId)[0].cartName;
    //       this.totalPrice = this.currentShoppingCarts.filter(i => i.cartId === cartId)[0].totalPrice;
    //     }

    //   }
    // },
    //   (error: any) => {
    //     console.error(error);
    //   });

    this.closesub$ = this.closeListener.close.subscribe(value => {
      if (value === type.SETTING_PAGE || value === type.SHOPPINGCART) {
        if (this.component) {
          this.component.destroy();
        }
        this.entry.clear();
        this.setCurrentToggle(0);
        $('app-chat-bot').hide();
        this.isDDAIOpen = false;
      }
    });

    this.update_TopNavUser();



    this.feedbackPopupSub$ = this._messageService.listen().subscribe((m: any) => {

      if (m === 'feedback') {
        $('#btnHelp').click();
        // this.setCurrentToggle(2);
      }
    });

    this.activeRouter.queryParamMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params)=>{
      if(params.has('searchfield')){
         this.searchField = params.get('searchfield');
      }
    });
    //this.addAnimation();
  }
  
  runBlink(responseMessage:string) {
    this.commonService.showSuccess("#topCartTotalValue", responseMessage, "bottom");
    this.blink = true;
    setTimeout(()=>{
      this.blink = false;
    },2000)
  }

  acceptSiteCookiePolicy() {
    this.commonService.createCookie("acceptCookiePolicy", "accepted", 365);
    $('#cookiePolicyBanner').fadeOut(400, function () { $(this).remove(); });
  }


  search(field: string) {
    if (field.length === 0) {
      return;
    }
    this.searchService.monitorSearchValueChange(field);
    const encodedField = encodeURIComponent(field.trim());
    const url = '/buy?globalSearch=' + encodedField;
    
    /**
     * In buy page, url is changed, but the router is not actually changed during advanced search, 
     * so we need to compare the actual url, if its same we need to make it different
     * otherwise it wont load
     */
    if (this._router.url == url) {
      this._router.navigateByUrl('/buy?globalSearch2=' + encodedField);
    } else {
      this._router.navigateByUrl(url);
    }
    // this._router.navigateByUrl('/buy?searchfield=' + encodedField);
  }

  setCurrentToggle = (index: number) => {
    if (!this.tourStep) {
      if (this.toggleOption !== index) {
        this.toggleOption = index;
      } else {
        this.toggleOption = 0;
      }
      let toggleComponent = null;
      switch (this.toggleOption) {
        case 1:
          toggleComponent = FeedBackComponent;
          break;
        case 2:
          toggleComponent = HelpComponent;
          break;
        case 3:
          toggleComponent = ShoppingCartComponent;
          break;
        case 4:
          toggleComponent = CompanyInformationComponent;
          break;
        case 5:
          toggleComponent = SettingComponent;
          break;
        case 6:
          toggleComponent = UserComponent;
          break;
        case 7:
          toggleComponent = LocationComponent;
          break;
      }

      if (this.entry) {
        this.entry.clear();
      }

      if (this.toggleOption > 0) {
        this.component = this.entry.createComponent(toggleComponent);

        if (toggleComponent === ShoppingCartComponent) {
          (<ShoppingCartComponent>this.component.instance).shoppingCartsInput = this.currentShoppingCarts;
        }

      }
    }
  }

  toggleDDAI = () => {
    if (this.isDDAIOpen) {
      $('app-chat-bot').hide();
      this.isDDAIOpen = false;
    } else {
      if (this.chatbotComponent) {
        $('app-chat-bot').show();
      } else {
        this.chatbotComponent = this.chatbot.createComponent(ChatBotComponent);
      }
      this.ddaiService.updateElementHeight();
      this.isDDAIOpen = true;
    }
  }

  clearToggle = () => {
    this.setCurrentToggle(0);
  }

  clearSearchBox(): void {
    this.searchField = '';
  }

  update_TopNavUser(): void {

    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;

      if (this.aliased !== res.isImpersonated) {
        this.commonService.savecookies('CartId', '', -1);
        // this.commonService.savecookies('LoginId', res.loginId, 10);
        this.aliased = res.isImpersonated;
      }
    },
      (error: any) => {
        // tslint:disable-next-line:no-console
        console.info(error);
      });
  }

  onChangeToggle(index: number, event: any) {

    event.stopPropagation();
    this.setCurrentToggle(index);
  }

  resetToggle() {
    // console.info('reset');
    this.setCurrentToggle(0);
  }

  addAnimation() {
    if (($('#globalSearch')?.length > 0)) {
      this.commonService.showSuccess('#globalSearch', 'Start your search here', 'bottom');
    }
  }

  nextTourStep(): void {
    this.commonService.monitorStepChange('step2');
  }

  nextTourStepTwo(): void {
    this.tourStep = '';
    this.commonService.monitorStepChange('step3');
  }

  previousTourStepOne(): void {
    this.tourStep = 'step1';
    this.popoverCart.close();
    this.commonService.monitorStepChange('step1');
  }

  closeCurrentTab() {
    this.authService.OCLogout().pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: ApiResponse) => {
      if (res.status) {
        // logout current session
        window.close();
      }
    });
  }
  
  public showSearchBar() {
    return this.authService.MENU_SECTION_1.find(i => i.menuId === 'orders');
  }

  ngAfterViewInit() {
    this.addAnimation();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
